<p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading...</span>
 </div>       
</p-blockUI>
<p-toast />
<div>
    <div class="flex flex-col mb-6">
        <h3 class="text-2xl font-bold text-surface-900 dark:text-surface-0 mb-1">Accounts</h3>
        <span class="text-surface-500 text-sm">Manage account settings and billing information</span>
    </div>

    <p-toolbar [style]="{ width: '70w' }">
        <ng-template #start #form>
            <p-iconfield iconPosition="left">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" [(ngModel)]="name" pInputText placeholder="Search" />

            </p-iconfield>
        </ng-template>
        <ng-template #end>

            <p-button (onClick)="showDialog()">New Account</p-button>  
        </ng-template>
    </p-toolbar>
</div>

    @if (accounts && accounts.length > 0) {
    <p-table [value]="filteredItems" [tableStyle]="{ 'min-width': '50rem' }"
             [paginator]="true" 
             [rows]="10"
             [rowsPerPageOptions]="[5, 10, 20, 50]">
        <ng-template #header>
            <tr>
                <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
                <th pSortableColumn="active">Status<p-sortIcon field="active" /></th> 
                <th>Actions</th>                
            </tr>
        </ng-template>
        <ng-template #body let-sub>
            <tr>
                <td>{{ sub.name }}</td>
                <td>{{ sub.active | booleanToActive}}</td>
                <td><i class="pi pi-pencil hover:cursor-pointer" (click)="showEditAccount(sub)" aria-label="Edit account" role="button" tabindex="0" (keydown.enter)="showEditAccount(sub)" (keydown.space)="$event.preventDefault(); showEditAccount(sub)"></i></td>
            </tr>
        </ng-template>
    </p-table>
 
    } @else {
        <div class="flex flex-col items-center justify-center py-12 text-center">
            <i class="pi pi-id-card text-4xl text-surface-400 mb-4"></i>
            <p class="text-lg text-surface-500 mb-4">No accounts found</p>
            <p-button label="New Account" icon="pi pi-plus" (click)="showDialog()"></p-button>
        </div>
    }

    <p-dialog header="Add new account" [modal]="true" [(visible)]="visible" [style]="{ width: '80w' }" (onShow)="loadData()">
      <p-fieldset legend="Account">
        <div class="flex flex-col">
            <div class="flex flex-row">
                <app-input-text [form]="accountForm" field="name" label="Account Name" placeholder="Account Name" class="mr-5"></app-input-text>
                <app-input-select [options]="statusOptions" field="active" label="Status" placeholder="Status" [form]="accountForm"></app-input-select>
            </div>
        </div>
      </p-fieldset>  
      <p-fieldset legend="Account Holder">
        <div class="flex flex-col">
            <div class="flex flex-row">
                <app-input-text [form]="accountForm" field="name" groupName="accountHolder" label="Name" placeholder="Name" class="mr-5"></app-input-text>
                <app-input-text [form]="accountForm" field="title" groupName="accountHolder" label="Title" placeholder="Title"></app-input-text>
            </div>
            <div class="flex flex-row">
                <app-input-text [form]="accountForm" field="email" groupName="accountHolder" label="Email" placeholder="Email" class="mr-5"></app-input-text>
                <app-input-text [form]="accountForm" field="businessAddress" groupName="accountHolder" label="Business Address" placeholder="Business Address"></app-input-text>    

            </div>
            <div class="flex flex-row">
                <app-input-mask [form]="accountForm" groupName="accountHolder" field="businessPhone" label="Business Phone" placeholder="Business Phone" class="mr-5"></app-input-mask>            
                <app-input-mask [form]="accountForm" groupName="accountHolder" field="mobilePhone" label="Mobile Phone" placeholder="Mobile Phone"></app-input-mask>
        
            </div>
        
            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="visible = false" />
                <p-button label="Save" (click)="save();" />
            </div>
        </div>  
      </p-fieldset>
    </p-dialog>

    <p-dialog header="Edit account" [modal]="true" [(visible)]="editVisible" [style]="{ width: '70w' }">

      <p-fieldset legend="Account">
        <div class="flex flex-col">
            <div class="flex flex-row">        
                <app-input-text [form]="editAccountForm" field="name" label="Account Name" placeholder="Account Name"  class="mr-5"></app-input-text>
                <app-input-select [options]="statusOptions" field="active" label="Status" placeholder="Active" [form]="editAccountForm"></app-input-select>
            </div>
        </div>
      </p-fieldset>  
      <p-fieldset legend="Account Holder">
        <div class="flex flex-col">
            <div class="flex flex-row">
                <app-input-text [form]="editAccountForm" field="name" groupName="accountHolder" label="Name" placeholder="Account Holders Name" class="mr-5"></app-input-text>
                <app-input-text [form]="editAccountForm" field="title" groupName="accountHolder" label="Title" placeholder="Account Holders Title"></app-input-text>
            </div>
            <div class="flex flex-row">
                <app-input-text [form]="editAccountForm" field="email" groupName="accountHolder" label="Email" placeholder="Account Holders Email" class="mr-5"></app-input-text>
                <app-input-text [form]="editAccountForm" field="businessAddress" groupName="accountHolder" label="Business Address" placeholder="Business Address"></app-input-text>
            </div>
            <div class="flex flex-row">
                <app-input-mask [form]="editAccountForm" groupName="accountHolder" field="businessPhone" label="Business Phone" placeholder="Business Phone" class="mr-5"></app-input-mask>            
                <app-input-mask [form]="editAccountForm" groupName="accountHolder" field="mobilePhone" label="Mobile Phone" placeholder="Mobile Phone"></app-input-mask>
            </div>
        

            <div class="flex justify-end gap-2">
                <p-button label="Cancel" severity="secondary" (click)="editVisible = false" />
                <p-button label="Save" (click)="updateSubscription();" />
            </div>
            
        </div>  
      </p-fieldset>        
    </p-dialog>
